<template>
	<div class="mt-100 mt-150-md">
		<h2 class="heading-5">Attachments</h2>
		<div v-for="(attachment, index) in props.attachments" :key="index" class="content-block">
			<BaseLink
				:link="{ href: attachment.file?.url, target: '_blank' }"
				class="display-inline-flex vertical-align-top align-items-center"
			>
				<BaseSvgIcon :name="fileIcon(attachment.file?.extension ?? '')" width="40" height="40" />
				<span class="display-block pl-100">
					<span class="display-block body-lg body-text-color"> {{ attachment.title }} </span>
					<span class="display-block body-xs muted">
						<span class="text-transform-uppercase">{{ attachment.file?.extension }}</span
						>&nbsp; &bull; &nbsp;{{ attachmentSize(attachment.file?.size ?? '') }}&nbsp;MB
					</span>
				</span>
			</BaseLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import big from 'big.js';
import { InvestorUpdateViewAttachment } from 'types/account';

interface Props {
	attachments: Array<InvestorUpdateViewAttachment>;
}

const props = defineProps<Props>();

function attachmentSize(sizeInBytes: string): string {
	return big(sizeInBytes).div(1000000).toFixed(1);
}

function fileIcon(extension: string): string {
	if (extension === 'pdf') {
		return 'pdf';
	} else if (extension === 'xls' || extension === 'xlsx') {
		return 'xls';
	} else {
		return 'docx';
	}
}
</script>
